// 1. Firebase 콘솔(https://console.firebase.google.com/)로 이동합니다.
// 2. 프로젝트를 선택한 후, 왼쪽 상단의 톱니바퀴 아이콘을 클릭하고 '프로젝트 설정'으로 이동합니다.
// 3. '내 앱' 섹션에서 웹 앱을 선택하거나 새로 만듭니다.
// 4. 'Firebase SDK 스니펫' 섹션에서 '구성'을 선택합니다.
// 5. 아래 객체에 해당 값을 복사하여 붙여넣으세요.

export const firebaseConfig = {
  apiKey: "AIzaSyBXAoHEhfgdtVbnQsrB692A4nR15To16H8",
  authDomain: "chul-jeong.firebaseapp.com",
  projectId: "chul-jeong",
  storageBucket: "chul-jeong.appspot.com",
  messagingSenderId: "918944233131",
  appId: "1:918944233131:web:381fdd203b7e31210ea9ee",
  measurementId: "G-NHNXTK12M7"
};